import { render, staticRenderFns } from "./GreetAddition.vue?vue&type=template&id=79aa8ece&scoped=true"
import script from "./GreetAddition.vue?vue&type=script&lang=js"
export * from "./GreetAddition.vue?vue&type=script&lang=js"
import style0 from "./GreetAddition.vue?vue&type=style&index=0&id=79aa8ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa8ece",
  null
  
)

export default component.exports